<div *ngFor="let log of logs" class="historic-log" fxLayout="row" fxLayoutAlign="center start">
  <div class="historic-log__description" fxFlex="45" fxFlex.xs="80">
    <div class="historic-card">
      <div class="historic-card__head">
        <div class="historic-card__icon-wrapper" *ngIf="log.rating">
          <i class="angularjs-fuse-icon historic-card__icon {{ log.emotion }} {{ log.status }}-fg"></i>
        </div>
        <div class="historic-card__title-wrapper">
          <p class="historic-card__title">{{ log.title }}</p>
          <p *ngIf="!log.rating" class="historic-card__subtitle {{ log.status }}-fg">{{ log.subtitle }}</p>
          <div *ngIf="log.rating" class="historic-card__stars">
            <i *ngFor="let star of log.stars" class="angularjs-fuse-icon {{ star }} {{ log.status }}-fg"></i>
          </div>
        </div>
      </div>

      <p class="historic-card__content" [innerHTML]="log.content"></p>

      <button
        *ngIf="log.button"
        mat-stroked-button
        class="historic-card__button"
        [disabled]="isOpeningMaintenanceDialog"
        (click)="log.button.action()"
      >
        {{ log.button.text }}
      </button>
    </div>
  </div>

  <div class="historic-log__icon" fxFlex="10" fxFlex.xs="20">
    <div class="historic-icon {{ log.status }}-bg">
      <i class="angularjs-fuse-icon {{ log.icon }}"></i>
    </div>
  </div>

  <div class="historic-log__time" fxFlex="45" fxHide.xs>
    <p class="historic-time">{{ log.createdAt }}</p>
    <p class="historic-updated-by" *ngIf="log.updatedBy" [innerHTML]="">
      {{ 'LOGS.UPDATED_BY' | translate: { name: log.updatedBy.name } }}
    </p>
  </div>
</div>
